import React from 'react';

const IndustryCard = ({ industry, index }) => {
  return (
    <article
      className="service-card industry-card relative overflow-hidden rounded-xl bg-primary-green-dark/20 shadow-card cursor-default"
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className="aspect-[4/3] sm:aspect-[3/2] md:aspect-video w-full overflow-hidden">
        <img
          src={industry.image}
          alt={industry.alt}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-t from-primary-dark via-primary-dark/55 to-transparent"></div>

      <div className="absolute inset-x-0 bottom-0 z-10 p-3 sm:p-4 md:p-6 text-left">
        <div className="mb-1.5 h-px w-8 bg-accent-gold md:mb-3 md:w-14"></div>
        <h3 className="text-xs sm:text-sm md:text-2xl font-semibold leading-snug text-white">
          {industry.title}
        </h3>
      </div>
    </article>
  );
};

const Services = () => {
  const industries = [
    {
      title: 'Aerospace Parts',
      image: '/industries/aerospace.jpg',
      alt: 'Precision aerospace components in an aircraft manufacturing environment',
    },
    {
      title: 'Fabrication Parts',
      image: '/industries/fabrication.jpg',
      alt: 'Industrial metal fabrication work with sparks in a manufacturing shop',
    },
    {
      title: 'Defence System Parts',
      image: '/industries/defence.jpg',
      alt: 'High precision defence engineering components and advanced manufacturing equipment',
    },
    {
      title: 'Railway Parts',
      image: '/industries/railway.jpg',
      alt: 'Railway rolling stock and heavy industrial rail engineering components',
    },
    {
      title: 'Automobile Parts',
      image: '/industries/automobile.jpg',
      alt: 'Automotive manufacturing line with vehicle components in production',
    },
    {
      title: 'Hydro Turbine & Generators',
      image: '/industries/hydro.jpg',
      alt: 'Hydro turbine and generator equipment for power generation',
    },
    {
      title: 'Power Industry Components',
      image: '/industries/power.jpg',
      alt: 'Industrial power generation plant and engineered power components',
    },
    {
      title: 'Electrical Components',
      image: '/industries/electrical.jpg',
      alt: 'Electrical components and control systems used in industrial engineering',
    },
    {
      title: 'General Engineering',
      image: '/industries/general.jpg',
      alt: 'Precision CNC machining for general engineering applications',
    },
  ];

  return (
    <section id="services" className="services py-14 md:py-24 px-[5%] bg-[#07110f] relative overflow-hidden" aria-labelledby="services-heading">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(176,228,204,0.09),transparent_38%,rgba(212,175,55,0.08))]"></div>
        <div className="absolute inset-0 opacity-[0.08] bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.8)_1px,transparent_1px)] [background-size:28px_28px]"></div>
      </div>

      <div className="relative z-10">
        <h2 id="services-heading" className="section-title text-center text-3xl md:text-4xl lg:text-5xl font-bold mb-8 md:mb-12 bg-gradient-to-r from-white via-primary-green-light to-accent-gold bg-clip-text text-transparent" aria-label="Precision machining industries served by Jay Ambe Engineering CNC work and VMC work">
          Industries We Serve
        </h2>

        <p className="text-center text-primary-green-light/80 text-base md:text-lg mb-10 md:mb-14 max-w-3xl mx-auto">
          Delivering precision engineering solutions across critical industries.
        </p>
        <p className="sr-only">
          Precision CNC parts manufacturer and precision VMC parts manufacturer for aerospace, fabrication, defence, railway, automobile, power, electrical and general engineering components.
        </p>

        <div className="services-grid grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-7 max-w-[1400px] mx-auto">
          {industries.map((industry, index) => (
            <IndustryCard
              key={industry.title}
              industry={industry}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
